import store from '@/store'
import { PostLogin200 } from '@/types/schemas/dashboard.schemas'
import { useStore } from 'vuex'

export default (): {
  updateBaseInfo: (username: string, info: PostLogin200, backend?: string) => void
} => {
  const { commit } = useStore()

  const updateBaseInfo = (
    username: string,
    { token, license, role, inChina }: PostLogin200,
    backend?: string,
  ) => {
    // console.log("--->username: ",username)
    // console.log("--->token: ",token)
    // console.log("--->license: ",license)
    // console.log("--->role: ",role)

    commit('UPDATE_USER_INFO', { token, username, role, inChina })
    commit('UPDATE_EDITION', license?.edition)
    // console.log(lang, theme, syncOsTheme)

    if (backend) {
      commit('UPDATE_LOGIN_BACKEND', backend)
    }
  }

  return {
    updateBaseInfo,
  }
}
